import request from '@/utils/request'

/**
 * 定制需求
 * @param data
 */
export const addDemand = (data) => {
  return request({
    url: '/sol/wap/reqs',
    method: 'post',
    data: data
  })
}

/**
 * 获取一级业态
 */
export const queryFirstType = () => {
  return request({
    url: '/sol/require/type',
    method: 'get'
  })
}

/**
 * 获取子业态/子系统
 * @param data
 */
export const querySecondType = (data) => {
  return request({
    url: '/sol/require/typeOrSystem',
    method: 'get',
    params: data
  })
}

/**
 * 根据业态获取系统
 * @param data
 */
export const querySystemType = (data) => {
  return request({
    url: '/sol/require/system/typeId',
    method: 'get',
    params: data
  })
}

/**
 * 获取省市
 * @param dataid
 */
export const queryProvince = (id) => {
  return request({
    url: `/sol/common/platform/area/${id}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/demands/demand.js